import React, { Component } from 'react'
import { connect } from 'react-redux'
import { list_update } from 'src/actions/timepoll'
import { userSelector } from 'src/selectors'
import PropTypes from 'prop-types'
import moment from 'moment'
import SignUpDetailCard from '../SignUpDetailCard/SignUpDetailCard'
import Button from 'components/common/Button'
import ReactTooltip from 'react-tooltip'
import CloseIcon from 'assets/icons/close-icon.png'
import BackIcon from 'assets/icons/back-icon.png'
import cn from 'classnames'
import { routerActions } from 'react-router-redux'

import EditIcon from 'assets/icons/edit-icon.png'
import styles from './draft-step.scss'
class DraftStep extends Component {
  getSignUpDetail = () => {
    const { signUpForm, user } = this.props
    return {
      name: signUpForm.name,
      image: signUpForm.checkedImage.url,
      avatar: user?.avatar.small_url_2x,
      eventName: signUpForm.checkedEvent?.name,
      ends_at: signUpForm.ends_at,
      createName: signUpForm.custom_creator_name
        ? signUpForm.custom_creator_name
        : `${user?.first_name} ${user?.last_name}`,
      created_at: moment().toDate(),
      notes: signUpForm.notes
    }
  }

  componentDidMount() {
    const { signUpForm } = this.props
    sessionStorage.setItem('signUpForm', JSON.stringify(signUpForm))
  }

  handleSubmit = () => {
    const { onSignUpFormSubmit, signUpForm, goSignUpDetail } = this.props
    const list_options_params = signUpForm.list_options_params

    const list_params = {
      email_require: signUpForm.email_require,
      name: signUpForm.name,
      custom_creator_name: signUpForm.custom_creator_name,
      notes: signUpForm.notes,
      event_id: signUpForm.checkedEvent?.id,
      image_upload_id: signUpForm.image_upload_id,
      poll_type: 'item',
      ends_at: signUpForm.ends_at,
      timezone: signUpForm.timezone
    }

    onSignUpFormSubmit({
      list_params,
      list_options_params,
      onSuccessCallback: data => {
        if (data.data.list_update.successful) {
          goSignUpDetail(data.data.list_update.result.token)
          sessionStorage.removeItem('signUpForm')
        }
      },
      onFailCallback: data => {
        if (!data.data.list_update.successful) {
          alert(data.data.list_update.messages[0])
        }
      }
    })
  }

  render() {
    const { signUpForm, onClickBack, goSignUpEdit } = this.props

    return (
      <div className={styles['draft-step-container']}>
        <img className={styles['back-icon']} src={BackIcon} width="40" onClick={onClickBack} />
        <div className={styles['draft-step-header']}>
          <img src={CloseIcon} onClick={onClickBack} width="18" />
          <span className={styles['header-text']}>draft sign up</span>
          <span className={styles['header-edit']} onClick={goSignUpEdit}>
            edit
          </span>
        </div>
        <div className={styles['draft-step-left']}>
          <div className={styles['draft-step-information']}>
            <SignUpDetailCard type="draft" signUpDetail={this.getSignUpDetail()} />
            <div className={styles['draft-step-button-wrapper']}>
              <div className={styles['draft-button']} onClick={goSignUpEdit}>
                <img src={EditIcon} alt="" width="20" />
                <span>edit draft</span>
              </div>
            </div>
          </div>
          <div className={styles['draft-save-wrapper']}>
            <Button
              className={cn(styles['button-inner'], styles['button-inner-save'])}
              onClick={this.handleSubmit}
            >
              save
            </Button>
          </div>
        </div>
        <div className={styles['draft-step-right']}>
          <div className={styles['draft-step-header']}>Slot/Item</div>
          <div className={styles['draft-step-option-wrapper']}>
            <ul className={styles['draft-step-option-ul']}>
              {signUpForm.list_options_params.map((item, index) => (
                <li className={styles['option-inner']} key={index}>
                  <div className={styles['option-title']}>
                    <span className={styles['option-name']}>{item.item}</span>
                    {item.count_limit !== 9999 && (
                      <div className={styles['option-number']}>
                        <label>count:</label>
                        <span>{item.count_limit}</span>
                      </div>
                    )}
                  </div>
                  <div
                    className={styles['option-description']}
                    data-for={'note-tooltip' + index}
                    data-tip
                  >
                    {item.description}
                  </div>
                  <ReactTooltip
                    id={'note-tooltip' + index}
                    effect="solid"
                    place="bottom"
                    backgroundColor="#9013FE"
                    borderColor="#9013FE"
                    className={styles['tooltip']}
                  >
                    <span>{item.description}</span>
                  </ReactTooltip>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

DraftStep.propTypes = {
  signUpForm: PropTypes.object,
  user: PropTypes.object,
  onSignUpFormSubmit: PropTypes.func,
  onClickBack: PropTypes.func,
  goSignUpDetail: PropTypes.func,
  goSignUpEdit: PropTypes.func
}

function mapStateToProps(state) {
  return {
    signUpForm: state.frontend.signUpForm,
    user: userSelector(state)
  }
}
function mapDispatchToProps(dispatch) {
  return {
    onSignUpFormSubmit: params => dispatch(list_update(params)),
    goSignUpDetail: token => dispatch(routerActions.push('/su/' + token)),
    goSignUpEdit: () => dispatch(routerActions.push('/su/edit'))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DraftStep)



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/SignUp/CreateSignUp/DraftStep/DraftStep.jsx